import { Injectable } from '@angular/core';
import { APIResponse } from 'src/app/core/models/api-response';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { ICommission, INewCommissionDTO } from '../models/commissions.models';

@Injectable({
  providedIn: 'root',
})
export class CommissionService {
  constructor(private http: HttpClient, private translateService: TranslateService) {}

  public getCommissions(): Observable<APIResponse<ICommission>> {
    return this.http.get<APIResponse<ICommission>>(
      environment.BASE_URL_API + 'commissions'
    );
  }

  public getCommissionById(id: number): Observable<APIResponse<ICommission>> {
    return this.http.get<APIResponse<ICommission>>(
      environment.BASE_URL_API + 'commissions/' + id
    );
  }

  public addCommission(commission: INewCommissionDTO): Observable<APIResponse<ICommission>> {
    return this.http.post<APIResponse<ICommission>>(
      environment.BASE_URL_API + 'commissions',
      commission
    );
  }

  public updateCommission(
    id: number,
    commission: Partial<INewCommissionDTO>
  ): Observable<APIResponse<ICommission>> {
    return this.http.patch<APIResponse<ICommission>>(
      environment.BASE_URL_API + 'commissions/' + id,
      commission
    );
  }

  public deleteCommissions(commission_ids: number[]): Observable<APIResponse<number>> {
    return this.http.post<APIResponse<number>>(
      environment.BASE_URL_API + 'commissions/bulk/delete',
      { commission_ids }
    );
  }

  public getCommissionCalculationTypes() {
    return [
      {
        value: 'order_discounted',
        label: this.translateService.instant('commission.calculation_types.order_discounted'),
      },
      {
        value: 'order_extra_discounted',
        label: this.translateService.instant('commission.calculation_types.order_extra_discounted'),
      },
      {
        value: 'agent_price',
        label: this.translateService.instant('commission.calculation_types.agent_price'),
      },
      {
        value: 'retail_price',
        label: this.translateService.instant('commission.calculation_types.retail_price'),
      },
    ];
  }

  public getDefaultCommissionCalculationTypeDesc() {
    const types = this.getCommissionCalculationTypes();

    return types[0].label
  }

  public getCommissionCalculationTypeDesc(type: 'order_discounted' | 'order_extra_discounted' | 'agent_price' | 'retail_price') {
    const types = this.getCommissionCalculationTypes();
    const found = types.find(item => item.value === type);
    return found ? found.label : types[0].label;
  }
}


